import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-pitch-bookings.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-pitch-bookings.php";
}

const PitchBookings = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },
  store(post) {
    return HTTP.post(API_SERVER, post);
  },
};

export { PitchBookings };
